export default function BrokenArrowMistakesSection() {
  const mistakes = [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long for Mission Trips",
      description: "Church groups often confirm mission trip rosters just 4–6 weeks before departure. Check all participant passports when rosters are finalized, not at the last minute. Many BA youth groups discover expired passports weeks before their Guatemala trip.",
    },
    {
      icon: "ri-camera-off-line",
      title: "Wrong Passport Photo",
      description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs so you get it right the first time — because a rejected photo can derail a last-minute mission departure or anniversary trip.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Missing Documents for Minors",
      description: "Child passports require both parents' presence or a notarized consent form. Prepare DS-3053 in advance — especially for single-parent families in Broken Arrow's youth groups and mission trips.",
    },
    {
      icon: "ri-pen-nib-line",
      title: "Not Using the Right Form",
      description: "First-time applicants use DS-11. Renewals use DS-82. Using the wrong form can cause weeks of delays. We provide the correct form with pre-filled instructions for every Broken Arrow applicant.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Ignoring the 6-Month Rule",
      description: "Many countries require 6 months of passport validity beyond your travel date. A passport expiring in 4 months may be rejected at the Tulsa airport. Many BA families discover this rule when their cruise booking rejects their passport.",
    },
    {
      icon: "ri-map-pin-time-line",
      title: "Not Checking Name Consistency",
      description: "Your passport name must match your driver's license and ticket exactly. Middle names, suffixes, and hyphenated names cause more rejections than you would think — and fixing them takes time Broken Arrow families and mission trip leaders simply do not have.",
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Emergency &amp; Expedited Passport Application Mistakes in Broken Arrow
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes cause the most delays and rejections for Broken Arrow travelers. Fast Passport Center reviews your documents before submission to catch these issues — so your mission trip, family vacation, or business conference stays on schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-[#F7F8FA] rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base">We check everything for you.</p>
            <p className="text-white/70 text-sm mt-1">
              Fast Passport Center reviews your documents before submission — so you do not have to worry about these mistakes causing a delay before your next international trip from Broken Arrow.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}